import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpHeaders,
  HttpErrorResponse,
  HttpContextToken,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// SC CATFER-9 se define una constante NO_SEND_HEADER, que permita indicar cuando es necesario añadirle token a la solicitud.
export const NO_SEND_HEADER = new HttpContextToken<boolean>(() => false);
@Injectable({
  providedIn: 'root',
})

//SC CATFER-9 Definir interceptor header.services: Servicio encargado de añadir a cada solicitud realizada el bearer token.
export class HeaderService implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let accessToken = this.authService.usuario.token;

    if (req.context.get(NO_SEND_HEADER) === true) {
      return next.handle(req);
    }
    accessToken = this.authService.usuario.token;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
    });

    const reqClone = req.clone({
      headers,
    });

    return next.handle(reqClone).pipe(
      // SC CATFER-9 Se agrega tambien los casos en que la respuesta de las solicitudes retornen un status code 401 y 403 (acceso no permitido o no autorizado por token no valido)
      catchError((response: HttpErrorResponse) => {
        if (response.status === 401 || response.status === 403) {
          // Call logout, but throttled!
          // this.throttleLogout.next();
          this.authService.logout();
        }
        return throwError(response);
      })
    );
  }
}
